import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  signupForm = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]),
    phone: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    password: new FormControl('', Validators.required)
  })
  constructor(
    private matSnackbar: MatSnackBar,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit(): void {
  }

  handleSignUp(){
    console.log(this.signupForm);
    let signupInfo = {
      first_name: this.signupForm.get('first_name').value,
      last_name: this.signupForm.get('last_name').value,
      email: this.signupForm.get('email').value,
      phone: this.signupForm.get('phone').value,
      password: this.signupForm.get('password').value,
      company_id: '123'
    }
    if (this.signupForm.valid) {
      const signupData = {
        ...this.signupForm.value,
        // roles: ['user']
      }
      this.authService.signup(signupInfo).subscribe(user => {
        if (user && user.AuthToken) {
          this.router.navigateByUrl('/home');
        } 
      },
      (error)=>{
        console.log(error);
      });
    }
    else {
      this.matSnackbar.open('Please fill all fields!', 'OK', { duration: 3000 })
    }
  }

  swichBetweenLoginSignup(){
    this.router.navigate(['/login']);
  }

}
